import axios from "axios";
import store from '../store'
import router from '../router'
import apiUrls from '../constants/apiUrls'
import  enviromentVariable from '../constants/enviromentVariable'

const INTERNALSERVERERROR = 500;
const UNAUTHORIZEDERROR = 401;

axios.interceptors.request.use((config) => {
    let token = store.getters.oidcIdToken;
    if (config.url.indexOf(apiUrls.UpdateContactDetailsIfAdfsGuidExistsUrl) == -1 && config.url.indexOf(apiUrls.GetUserStatusByUserNames) == -1)
        store.dispatch("triggerSilentLogin");//This will increase the value in store and there is a watch written on App.vue that trigger the silentlogin.
    config.headers = {
        "Authorization": "bearer " + token,
        "AccountIdsHash": store.getters.accountIdsHash,
        "content-type": "application/json"
    };
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use(
    response => {
        store.dispatch("resetIsApiRequested");
        return response
    },
    error => {
        //console.log(error);
        store.dispatch("resetIsApiRequested");
        const status = error.response ? error.response.status : null;
        if (status === INTERNALSERVERERROR) {
            router.push('error');
        }
        else if (status === UNAUTHORIZEDERROR) {
            var currentPath = (window.location.pathname || "").toLowerCase();
            if (currentPath.indexOf("callback") !== -1) {
                return Promise.reject(error);
            }
            if (currentPath.indexOf("unauthorize") === -1) {
                router.push('unauthorize');
            }
        }
        return Promise.reject(error);
    }
);

export default {
    async GetAccountContactRolesByAccountId(sfAccountId) {
        return new Promise(function (resolve, reject) {
            let roles = store.getters.roles;
            let accountRoles = roles.filter(p => p.accountId == sfAccountId)[0];
            if (accountRoles == null) {
                axios.get(apiUrls.GetAccountContactRolesByAccountIdUrl + sfAccountId)
                    .then(response => {
                        store.dispatch("addRoles", { accountId: sfAccountId, accountRoles: response.data });
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    })
            }
            else {
                resolve(accountRoles.accountRoles);
            }
        });
    },//accessibleApplication
    GetAccessiblePermission(username, accountNumber) {
        //return new Promise(function (resolve, reject) {
        //    let applications = store.getters.accessibleApplication;
        //    let application = applications.filter(p => p.username == username && p.accountNumber == accountNumber)[0];
        //    if (application == null) {
        //        axios.get(apiUrls.GetAccessibleApplicationsUrl + username + "/" + accountNumber)
        //            .then(response => {
        //                store.dispatch("addAccessibleApplication", { username: username, accountNumber: accountNumber, applications: response });
        //                resolve(response);
        //            })
        //            .catch(error => {
        //                reject(error);
        //            })
        //    }
        //    else {
        //        resolve(applications.applications);
        //    }
        //});
        return axios.get(apiUrls.GetAccessibleApplicationsUrl + username + "/" + accountNumber);
    },
    EnableCustomerCommunity(userDetail) {
        return axios.post(apiUrls.EnableCustomerCommunity, userDetail);
    },
    UpdateUser(userDetail) {
        return axios.put(apiUrls.UpdateUserUrl, userDetail);
    },
    UpdateUserPermission(userDetail) {
        return axios.put(apiUrls.UpdateUserPermissionUrl, userDetail);
    },
    CreateUser(userDetail) {
        return axios.post(apiUrls.CreateUserUrl, userDetail);
    },
    UpdateUserStatus(userStatusDetail) {
        return axios.post(apiUrls.ToggleUserStatusUrl, userStatusDetail);
    },
    ResetUserPassword(resetPasswordObj) {
        return axios.post(apiUrls.ResetUserPasswordUrl, resetPasswordObj);
    },
    GetContactByContactId(sfContactId) {
        return axios.get(apiUrls.GetContactByContactIdUrl + sfContactId);
    },
    GetUserAccountsByEmailId(email) {
        return axios.get(apiUrls.GetUserAccountsByEmailIdUrl + email);
    },
    GetEditingUserDetails(sfAccountId, sfContactId) {
        return axios.get(apiUrls.GetEditingUserDetails + sfAccountId + "/" + sfContactId);
    },
    UnlockUser(userDetail) {
        return axios.post(apiUrls.UnlockUserUrl, userDetail);
    },
    GetAdfsUserStatus(adfsGuid) {
        return axios.get(apiUrls.GetAdfsUserStatusUrl + adfsGuid);
    },
    GetUserDetailsByAccountId(sfAccountId) {
        return axios.get(apiUrls.GetUserDetailsByAccountIdUrl + sfAccountId);
    },
    ConfirmAndSaveUser(userdetailsConfirm) {
        return axios.put(apiUrls.ConfirmAndSaveUserUrl, userdetailsConfirm);
    },
    async GetAllPermissions(sfAccountId) {
        return new Promise(function (resolve, reject) {
            let accountNumber=""
            let permissions = store.getters.permissions;
            let accountPermissions = permissions.filter(p => p.accountId == sfAccountId)[0];
            if (accountPermissions == null) {
                let cbAccount = store.getters.adminAccounts.filter(a => a.accountId == sfAccountId)[0]
                if (typeof cbAccount != "undefined" && cbAccount != null)
                    accountNumber = cbAccount.accountNumber
                axios.get(apiUrls.GetAllPermissionsUrl + sfAccountId + "/" + accountNumber)
                    .then(response => {                      
                        store.dispatch("addPermissions", { accountId: sfAccountId, accountPermissions: response.data });
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    })
            }
            else {
                resolve(accountPermissions.accountPermissions);
            }
        });
    },
    RemoveAccount(data) {
        return axios.delete(apiUrls.RemoveAccountForUserUrl, { data: data });
    },
    RemoveAllAccount(url, data) {
        return axios.delete(url, { data: data });
    },
    GetLoggedInUserInfo() {
        return new Promise(function (resolve, reject) {
            let token = store.getters.oidcIdToken;
            if (token) {
                axios.get(apiUrls.GetLoggedInUserInfoUrl)
                    .then(dataresult => {
                        let accounts = [];
                        if (dataresult.data.accountHierarchy != null && dataresult.data.accountHierarchy.length > 0) {
                            var primaryAccount = dataresult.data.primaryAccount;
                            store.dispatch("setErrorMessage", dataresult.data.errorMessage);
                            store.dispatch("setAccountIdsHash", dataresult.data.userAdminSFAccountIdsHash);
                            store.dispatch("setAccountHierarchy", dataresult.data.accountHierarchy);
                            store.dispatch("setPrimaryAccount", primaryAccount);
                            store.dispatch("setLoggedInUserAdfsGuid", dataresult.data.adfsGuid);
                            dataresult.data.accountHierarchy.forEach(function (parent) {
                                accounts.push({
                                    accountName: parent.accountName,
                                    accountNumber: parent.accountNumber,
                                    accountId: parent.accountId,
                                    hideInactiveContact: parent.hideInactiveContact
                                });
                                if (parent.children != null) {
                                    parent.children.forEach(function (child) {
                                        accounts.push({
                                            accountName: child.accountName,
                                            accountNumber: child.accountNumber,
                                            accountId: child.accountId,
                                            hideInactiveContact: parent.hideInactiveContact
                                        });
                                        if (child.children != null) {
                                            child.children.forEach(function (grandChild) {
                                                accounts.push({
                                                    accountName: grandChild.accountName,
                                                    accountNumber: grandChild.accountNumber,
                                                    accountId: grandChild.accountId,
                                                    hideInactiveContact: parent.hideInactiveContact
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                            store.dispatch("setAdminAccounts", accounts);
                            store.dispatch("setLanguagePreference", dataresult.data.languagePreference);
                        }
                        resolve();
                    })
                    .catch(error => {
                        console.log('error', error);
                        reject(error);
                    });
            }
            else
                reject("InvalidToken");
        });
        //return axios.get(apiUrls.GetLoggedInUserInfoUrl);
    },
    async UpdateContactDetailsIfAdfsGuidExists(userDetail) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                axios.post(apiUrls.UpdateContactDetailsIfAdfsGuidExistsUrl, userDetail)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            }, 1000);
        });
    },
    async GetAdfsUserStatusByUserNames(userNames) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                axios.post(apiUrls.GetUserStatusByUserNames, userNames )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            }, 1000);
        });
    },
    SetUserAction(emailAddress, sfAccountId) {
        return axios.get(apiUrls.SetUserAction + emailAddress + "/" + sfAccountId);
    },
    UpdateContactBasicInfo(patchObject) {
        return axios.put(apiUrls.UpdateContactBasicInfoUrl, patchObject);
    },
    GetEnviromentVariables() {
        return new Promise(function (resolve) {
            axios.get(apiUrls.GetEnviromentVariables).then(response => {
                //enviromentVariable.authority = response.data.authority;
                //enviromentVariable.clientId = response.data.clientId;
                //enviromentVariable.uri = response.data.userManagementUrl;
                enviromentVariable.manageUserNotificationUrl = response.data.manageUserNotificationsUrl;
                enviromentVariable.customerCommunityUrl = response.data.customerCommunityUrl;
                enviromentVariable.tokenExpireMessage = response.data.tokenExpireMessage;
                enviromentVariable.noticeToEndUserStartingDate = response.data.noticeToEndUserStartingDate;
                enviromentVariable.isInvalidDateForNotice = response.data.isInvalidDateForNotice;       
                resolve();
            });
        });
    },
    SetUserManagementAppSetting(account, adfsGuid) {
        return axios.post(apiUrls.SetUserManagementAppSettingUrl + adfsGuid, account);
    }
}